import axios from "axios";
import Server from "@/assets/js/servers.js";
import data from "@/assets/js/data.js";

let getNum = n => n<10?('0' + n):n;
export default {
    async init({commit,state},fn){ //基本设置
        if(state.systemInfo.company_name_cn)return;
        try{
            let res = await axios.get(Server.base);
            if(res.code == 0){
                commit('init',res.data);
                fn();
            }
        }catch(e){
            console.log(e);
        }
    },
    async initHome({commit}){ //首页数据
        try{
            let res = await axios.get(Server.home);
            if(res.code == 0){
                let tmp = res.data;
                tmp.bestNews.map(item=>{
                    let tmpDate = new Date(item.created.ts*1000);
                    item.formateMonth = getNum(tmpDate.getMonth() + 1);
                    item.formateDay = getNum(tmpDate.getDate());
                    return item;
                });
                commit('home',res.data);
            }
        }catch(e){
            console.log(e);
        }
    },
    async getCommonColumns({commit,state},fn){ //公共栏目
        if(state.columns.length>0)return fn();
        try{
            let res = await axios.get(Server.about_columns);
            if(res.code == 0){
                commit('columns',res.data.map(item => {
                    item.route_name = data.route[item.menu_name];
                    return item;
                }));
                fn();
            }
        }catch(e){
            console.log(e);
        }
    },
    async getProductData({commit,state}, dataStr = "page=1"){ //产品展示
        try{
            let res = await axios.get(Server.product+"?"+dataStr);
            if(res.code == 0){
                commit('productColumns',res.data.classList);
                commit('productList',res.data.data.items);
                commit('productTotal',res.data.data.totalPage);
            }
        }catch(e){
            console.log(e);
        }
    },
    async getNewsData({commit,state}, dataStr = "page=1"){ //新闻中心
        try{
            let res = await axios.get(Server.news+"?"+dataStr);
            if(res.code == 0){
                res.data.data.items.map(item=>{
                    let tmpDate = new Date(item.created.ts*1000);
                    item.formateYear = tmpDate.getFullYear();
                    item.formateDate = getNum(tmpDate.getMonth() + 1)+"-"+getNum(tmpDate.getDate());
                    return item;
                });
                commit('newsColumns',res.data.classList);
                commit('newsList',res.data.data.items);
                commit('newsTotal',res.data.data.totalPage);
            }
        }catch(e){
            console.log(e);
        }
    },
}



// WEBPACK FOOTER //
// ./src/store/actions.js